'use client'

import Script from 'next/script'
import DidomiUI from 'ui/src/components/didomi/didomi'
import { publicRuntimeConfig } from './env'

// TODO copied from @next/third-parties as it has type issues

export type DidomiIds = {
    default: string
    consentOnEngagement: string
}

export const DIDOMI_IDS: DidomiIds = {
    default: 'CnUtpQ7h', // user must click "Agree" button on Didomi notice
    consentOnEngagement: 'YjTZPQHB', // consent is automatically granted on scroll or click
}

type GTMParams = {
    gtmId: string
    dataLayer?: string[]
    dataLayerName?: string
    auth?: string
    preview?: string
    didomiIds?: DidomiIds
}

let currDataLayerName: string | undefined = undefined

export function getDidomiBootstrapScript(didomiIds: DidomiIds) {
    return `
        function showBanner(id) {
            window.gdprAppliesGlobally=true;(function(){
            function addLocatorFrame(name){if(!window.frames[name]){if(document.body&&document.body.firstChild){var target=document.body;var frame=document.createElement("iframe");frame.style.display="none";frame.name=name;frame.title=name;target.insertBefore(frame,target.firstChild)}
            else{setTimeout(function(){addLocatorFrame(name)},5)}}}
            function installTcfStub(apiName,bufferName,callName,returnName,makeStub){function stub(command,version,callback,parameter){if(typeof callback!=="function"){return}if(!window[bufferName]){window[bufferName]=[]}var handled=false;if(makeStub){handled=makeStub(command,parameter,callback,version)}if(!handled){window[bufferName].push({command:command,parameter:parameter,callback:callback,version:version})}}stub.stub=true;stub.stubVersion=2;function handleMessage(event){if(!window[apiName]||window[apiName].stub!==true){return}if(!event.data){return}
            var isString=typeof event.data==="string";var payload;try{payload=isString?JSON.parse(event.data):event.data}catch(error){return}if(payload[callName]){var call=payload[callName];window[apiName](call.command,call.version,function(returnValue,success){var response={};response[returnName]={returnValue:returnValue,success:success,callId:call.callId};if(event.source){event.source.postMessage(isString?JSON.stringify(response):response,"*")}},call.parameter)}}if(typeof window[apiName]!=="function"){window[apiName]=stub;if(window.addEventListener){window.addEventListener("message",handleMessage,false)}else{window.attachEvent("onmessage",handleMessage)}}}
            function installGppStub(){function getPingData(){return{gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",supportedAPIs:[],cmpId:0,sectionList:[],applicableSections:[-1],gppString:"",parsedSections:{}}}
            function gppStub(command,callback,parameter,version){gppStub.queue=gppStub.queue||[];gppStub.events=gppStub.events||[];gppStub.lastListenerId=gppStub.lastListenerId||0;if(command==="ping"){if(typeof callback==="function"){callback(getPingData(),true)}return}
            if(command==="addEventListener"){if(typeof callback!=="function"){return}gppStub.lastListenerId+=1;var listenerId=gppStub.lastListenerId;gppStub.events.push({id:listenerId,callback:callback,parameter:parameter});callback({eventName:"listenerRegistered",listenerId:listenerId,data:true,pingData:getPingData()},true);return}
            if(command==="removeEventListener"){if(typeof callback!=="function"){return}var removed=false;var listenerId=Number(parameter);gppStub.events=gppStub.events.filter(function(listener){var matches=listener.id===listenerId;if(matches){removed=true}return !matches});callback({eventName:"listenerRemoved",listenerId:listenerId,data:removed,pingData:getPingData()},true);return}
            if(command==="hasSection"||command==="getSection"||command==="getField"){if(typeof callback==="function"){callback(null,true)}return}
            gppStub.queue.push([].slice.call(arguments))}
            function handleMessage(event){var isString=typeof event.data==="string";var payload;try{payload=isString?JSON.parse(event.data):event.data}catch(error){return}if(typeof payload!=="object"||payload===null||!("__gppCall" in payload)){return}
            var call=payload.__gppCall;window.__gpp(call.command,function(returnValue,success){var response={__gppReturn:{returnValue:returnValue,success:success,callId:call.callId}};if(event.source){event.source.postMessage(isString?JSON.stringify(response):response,"*")}},"parameter" in call?call.parameter:null,"version" in call?call.version:"1.1")}
            if(typeof window.__gpp!=="function"){gppStub.stub=true;gppStub.stubVersion="1.1";window.__gpp=gppStub;if(window.addEventListener){window.addEventListener("message",handleMessage,false)}else{window.attachEvent("onmessage",handleMessage)}addLocatorFrame("__gppLocator")}}
            installTcfStub("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");addLocatorFrame("__tcfapiLocator");installGppStub();(function(e,tgt){
            var t=document.createElement("script");t.id="spcloader";t.type="text/javascript";t.async=true;t.src="https://sdk.privacy-center.org/"+e+"/loader.js?target_type=notice&target="+tgt;t.charset="utf-8";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)})("8878f527-7872-49a5-abd4-f6b2e56cb64a",id)})();
        };
        fetch('https://giphy.com/api/geolocation')
            .then((resp) => resp.json())
            .then(function(response) {
            window.didomiConfig = {
                    notice: {
                        content: {
                            dismiss: {
                            en: 'Agree',
                            },
                            deny: {
                            en: 'Disagree',
                            },
                            learnMore: {
                            en: 'Manage Cookies',
                            }
                        }
                    }
                }
                if(response.region === 'CA' || response.continentCode === "EU"){
                showBanner("${didomiIds['default']}")
                } else {
                showBanner("${didomiIds['consentOnEngagement']}")
                }
            }).catch((err) => {
                showBanner("${didomiIds['default']}")
            })`
}

export function GoogleTagManager(props: GTMParams) {
    const { gtmId, didomiIds = DIDOMI_IDS, dataLayerName = 'dataLayer', auth, preview, dataLayer } = props

    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName
    }

    const gtmLayer = dataLayerName !== 'dataLayer' ? `$l=${dataLayerName}` : ''
    const gtmAuth = auth ? `&gtm_auth=${auth}` : ''
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : ''

    return (
        // Order is important to Didomi: https://developers.didomi.io/cmp/web-sdk/getting-started#script
        <>
            <DidomiUI />
            <Script
                type="didomi/javascript"
                id="_next-gtm-init"
                dangerouslySetInnerHTML={{
                    __html: `
                    (function(w,l){
                        w[l]=w[l]||[];
                        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                        ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
                    })(window,'${dataLayerName}');`,
                }}
            />
            <Script
                type="didomi/javascript"
                id="_next-gtm"
                src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}`}
            />
            {!publicRuntimeConfig.isPlaywright && (
                <Script
                    id="didomi"
                    strategy="afterInteractive"
                    dangerouslySetInnerHTML={{
                        __html: getDidomiBootstrapScript(didomiIds),
                    }}
                />
            )}
        </>
    )
}

export const sendGTMEvent = (data: Object) => {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GTM has not been initialized`)
        return
    }

    // @ts-ignore
    if (window[currDataLayerName]) {
        // @ts-ignore
        window[currDataLayerName].push(data)
    } else {
        console.warn(`@next/third-parties: GTM dataLayer ${currDataLayerName} does not exist`)
    }
}
